// Check and enforce swatch product quantities in cart to be at most 1 per item.
// in component-cart-item.liquid we are also disabling the quantity selectors for swatch products.
(function () {
  'use strict';

  const CONFIG = {
    maxOneProductHandle: window.themeSettings?.max_qty_one_product || null,
  };

  let enforcementRunning = false;
  let isEnforcementUpdate = false;

  function isMaxOneProduct(item) {
    return CONFIG.maxOneProductHandle && item.handle === CONFIG.maxOneProductHandle;
  }

  async function updateItemQuantity(key, quantity) {
    try {
      isEnforcementUpdate = true;
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      });
      if (!response.ok) throw new Error('Failed to update cart');
      const result = await response.json();
      isEnforcementUpdate = false;
      return result;
    } catch (error) {
      console.error('Error updating max qty product:', error);
      isEnforcementUpdate = false;
      throw error;
    }
  }

  async function enforceMaxOneQuantities(depth = 0) {
    if (enforcementRunning || depth > 3 || !CONFIG.maxOneProductHandle) return;
    
    enforcementRunning = true;

    try {
      const response = await fetch('/cart.js', { cache: 'no-store' });
      const cart = await response.json();

      const itemsToFix = cart.items.filter(item =>
        isMaxOneProduct(item) && item.quantity > 1
      );

      if (itemsToFix.length === 0) {
        if (depth > 0 && window.Cart?.updateCart) {
          await window.Cart.updateCart(false);
        }
        enforcementRunning = false;
        return;
      }

      for (const item of itemsToFix) {
        await updateItemQuantity(item.key, 1);
        await new Promise(resolve => setTimeout(resolve, 100));
      }

      enforcementRunning = false;

      await new Promise(resolve => setTimeout(resolve, 300));
      await enforceMaxOneQuantities(depth + 1);

    } catch (error) {
      console.error('Error enforcing max one quantities:', error);
      enforcementRunning = false;
    }
  }

  function hookFetch() {
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : args[0]?.url;

        if (url && /\/cart\/(add|change|update)\.js/i.test(url) && !isEnforcementUpdate) {
          const clone = response.clone();
          clone.json().then(async () => {
            await new Promise(resolve => setTimeout(resolve, 500));
            enforceMaxOneQuantities();
          }).catch(() => {});
        }
      } catch (_) {}
      return response;
    };
  }

  function init() {
    if (!CONFIG.maxOneProductHandle) {
    // console.log('No max quantity product configured');
      return;
    }
    
    hookFetch();
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => {
        setTimeout(enforceMaxOneQuantities, 1000);
      });
    } else {
      setTimeout(enforceMaxOneQuantities, 1000);
    }
  }

  init();
})();